export default __webpack_public_path__ + "static/media/Notebook_perspective_matte_s.32a7ab8a.png";